import React from "react";
import PropTypes from "prop-types";
import useStyles from "./styles";
import { Typography, Card } from "@material-ui/core";

const Tile = ({ title, count }) => {
  const classes = useStyles();
  return (
    <div className={classes.orderCardContainer}>
      <Card className={classes.orderCard}>
        <div>
          <Typography className={classes.openOrdersTitle} color="textSecondary">
            {title}
          </Typography>
          <Typography className={classes.openOrdersCount}>{count}</Typography>
        </div>
      </Card>
    </div>
  );
};

Tile.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired
};

export default Tile;
